import gql from "graphql-tag";

import { Fragment, Campaign } from "../types";

export const CAMPAIGN_MINIMAL_FRAGMENT = gql`
  fragment CampaignMinimalFragment on Campaign {
    id
    slug
    name
    description
    canShow
    canInsert
    madsCount
  }
`;

export type CampaignMinimalFragment = Fragment<
  Campaign,
  Pick<Campaign, "id" | "slug" | "name" | "description" | "canShow" | "canInsert" | "madsCount">
>;
